import React, { useState, useEffect } from "react";
import _ from 'lodash'
import "./preload.css";
import { useSelector } from "react-redux";

export default function LayoutPreload() {

  const height = useSelector(({ home }) => home.containerHeight);

  useEffect(() => {
    window.scrollTo(0, 0)
  });

  return (
    <div className="container-loader" style={{ height }}>
      <div className="layout-loader-mask">
        <div className="layout-loader">"Loading..."</div>
      </div>
    </div>
  );
}
